export const Insurances = {
  label: 'Versicherungen',
  itemId: 'insurances',
  url: '/kfz-versicherung ',
  useRouter: true,
};
